import * as React from 'react';
import * as styles from './TimeStreamToolboxCanvas.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import useProjectsToolbox from '../hooks/useProjectsToolbox';
import {
    getToolboxHeight,
    toolboxVerticalMargin,
    toolboxHorizontalMargin,
    shouldShowExpandedToolbox,
    useToolboxState,
} from 'owa-timestream-toolbox-common';
import TimeStreamToolsToolbox from './TimeStreamToolsToolbox';
import { toolboxRegionName } from './TimeStreamToolbox.locstring.json';
import SkipLinkRegionToFirstFocusableChild from 'owa-skip-link/lib/components/SkipLinkRegionToFirstFocusableChild';
import { shouldShowProjectsToolbox, hideProjectsToolbox } from '../viewstate';

export default observer(function TimeStreamToolbox() {
    const { LazyTimeStreamProjectsToolbox } = useProjectsToolbox();
    const { toolboxRef } = useToolboxState();
    const showProjectsToolbox = shouldShowProjectsToolbox();
    const toolboxExpanded = shouldShowExpandedToolbox();
    const toolboxClassName = classNames(styles.toolbox, {
        [styles.expandedToolbox]: toolboxExpanded || showProjectsToolbox,
    });

    return (
        <SkipLinkRegionToFirstFocusableChild
            role="region"
            regionNameResourceId={toolboxRegionName}
            className={toolboxClassName}
            ref={toolboxRef}
            style={{
                height: getToolboxHeight(),
                margin: `${toolboxVerticalMargin}px ${toolboxHorizontalMargin}px`,
            }}>
            {LazyTimeStreamProjectsToolbox && showProjectsToolbox ? (
                <LazyTimeStreamProjectsToolbox hideProjectsToolbox={hideProjectsToolbox} />
            ) : (
                <TimeStreamToolsToolbox />
            )}
        </SkipLinkRegionToFirstFocusableChild>
    );
});
